<footer class="bg-slate-950 pt-16 pb-8 text-gray-300" role="contentinfo">
    <div class="mx-auto max-w-7xl px-6">
        <!-- TOP SECTION -->
        <div class="grid gap-10 md:grid-cols-2 lg:grid-cols-5">
            <!-- BRAND -->
            <div class="lg:col-span-2">
                <a href="/" class="mb-4 flex items-center">
                    <img
                        src="assets/logo/hairstyleclub-full-logo.png"
                        class="h-10"
                        alt="Hair Style Club"
                        loading="lazy" />
                </a>

                <p
                    fontSpanish
                    class="max-w-md text-sm leading-relaxed text-gray-400">
                    {{ 'landing.footer.description' | transloco }}
                </p>

                <!-- SOCIAL -->
                <div class="mt-6 flex gap-4">
                    <a
                        href="https://www.facebook.com/BaboorOfficial"
                        class="hover:bg-primary flex h-10 w-10 items-center justify-center rounded-full bg-slate-800 transition"
                        aria-label="Hair Style Club Facebook">
                        <i class="pi pi-facebook"></i>
                    </a>

                    <a
                        href="https://www.linkedin.com/company/baboor"
                        class="hover:bg-primary flex h-10 w-10 items-center justify-center rounded-full bg-slate-800 transition"
                        aria-label="Hair Style Club LinkedIn">
                        <i class="pi pi-linkedin"></i>
                    </a>
                </div>
            </div>

            <!-- FEATURES -->
            <div>
                <h3
                    fontSpanish
                    class="mb-5 text-sm font-semibold text-white uppercase">
                    {{ 'landing.footer.features' | transloco }}
                </h3>

                <ul class="space-y-3 text-sm">
                    <li>
                        <a
                            fontSpanish
                            routerLink="/shops"
                            class="hover:text-primary-light transition">
                            {{ 'landing.footer.browseShops' | transloco }}
                        </a>
                    </li>

                    <li>
                        <a
                            fontSpanish
                            href="/signup"
                            class="hover:text-primary-light transition">
                            {{ 'landing.footer.tryBaboor' | transloco }}
                        </a>
                    </li>

                    <li>
                        <a
                            fontSpanish
                            routerLink="/privacy-policy"
                            class="hover:text-primary-light transition">
                            {{ 'landing.footer.privacyPolicy' | transloco }}
                        </a>
                    </li>
                </ul>
            </div>

            <!-- COMPANY -->
            <div>
                <h3
                    fontSpanish
                    class="mb-5 text-sm font-semibold text-white uppercase">
                    {{ 'landing.footer.company' | transloco }}
                </h3>

                <ul class="space-y-3 text-sm">
                    <li>
                        <a
                            fontSpanish
                            href="/about-us"
                            class="hover:text-primary-light transition">
                            {{ 'landing.footer.aboutUs' | transloco }}
                        </a>
                    </li>

                    <li>
                        <a
                            fontSpanish
                            href="/contact-us"
                            class="hover:text-primary-light transition">
                            {{ 'landing.footer.contactUs' | transloco }}
                        </a>
                    </li>
                </ul>
            </div>

            <!-- CONTACT -->
            <div>
                <h3
                    fontSpanish
                    class="mb-5 text-sm font-semibold text-white uppercase">
                    {{ 'landing.footer.contact' | transloco }}
                </h3>

                <ul class="space-y-3 text-sm">
                    <li class="flex items-center gap-2">
                        <i class="pi pi-envelope text-primary-light"></i>
                        <span>info&#64;baboor.com</span>
                    </li>
                </ul>
            </div>
        </div>

        <!-- DIVIDER -->
        <div class="my-6 border-t border-slate-800"></div>

        <!-- BOTTOM -->
        <div
            class="flex flex-col items-center justify-between gap-4 text-sm text-gray-400 md:flex-row">
            <span fontSpanish>
                © {{ year }}
                <a fontSpanish href="/" class="hover:text-primary-light">{{
                    'global.projectName' | transloco
                }}</a
                >. {{ 'landing.footer.allRightsReserved' | transloco }}
            </span>

            <span
                fontSpanish
                class="rounded-full border border-gray-700 bg-slate-800 px-3 py-1 text-xs text-gray-400">
                {{ 'landing.footer.version' | transloco }} {{ version() }}
            </span>
        </div>
    </div>
</footer>
